import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resetOrder } from '../../../store/actions';
import Button from "@material-ui/core/Button";
import history from '../../../../../src/history';
import {
    infoColor,
} from "assets/jss/material-kit-pro-react.js";
import authService from '../../../../components/api-authorization/AuthorizeService';
import { withRouter } from "react-router-dom";
import $ from 'jquery';
import { compose } from "redux";
import packageJson from '../../../../../../ClientApp/package.json';

class ViewOrderButton extends Component {


    handleClick = async () => {
        await this.props.resetOrder();
        await this.CheckVersion();
    }


    async CheckVersion() {
        try {
            const ver = packageJson.releaseVersionNo;
            const token = await authService.getAccessToken();

            const response = await fetch('api/data/getlatestversion/', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            const ret = await response.json();

            if (ver === ret.message) {
                this.props.history.push("/ReviewOrder");
            }
            else {
                window.location.reload();
            }

        }
        catch (e) {

        }
    }

    render() {
        return (
                <Button
                    onClick={this.handleClick}
                    style={{
                        borderRadius: 15,
                        backgroundColor: infoColor[1],
                        padding: "clamp(8px, 2.2vw, 16px) clamp(14px, 4.5vw, 32px)",
                        fontSize: "clamp(16px, 2.2vw, 30px)",
                        color: "#FFFFFF",
                        whiteSpace: "nowrap",
                        lineHeight: "1.2",
                        fontFamily: '"Helvetica Neue Condensed 77","Helvetica Neue",Arial,sans-serif',
                    }}
                    size="large"
                    target="_blank"
                >
                    <i className="fas fa-list-ol"></i>
                    &nbsp; Review Order
                </Button>
        )


    };
}


export default compose(withRouter,connect(null, { resetOrder }))(ViewOrderButton);